import { render, staticRenderFns } from "./show.vue?vue&type=template&id=a6b6339a&scoped=true&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"
import style0 from "./show.vue?vue&type=style&index=0&id=a6b6339a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b6339a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6b6339a')) {
      api.createRecord('a6b6339a', component.options)
    } else {
      api.reload('a6b6339a', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=a6b6339a&scoped=true&", function () {
      api.rerender('a6b6339a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44-unknown-volume/show.vue"
export default component.exports